import React from 'react';
import { Slider, Radio, Tooltip, InputNumber, Menu, Dropdown, Icon, Button, Input } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

import ModelCssLengthProperty from "../../designer/diagrams/ModelCssLengthProperty";

export default class CssLengthEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {
        super.componentWillMount();
    }

    onPercentChange(e) {
        this.props.source.value = new ModelCssLengthProperty({
            mode: "percent",
            value: e,
        });
        this.setState({});
    }

    onPxChange(e) {
        this.props.source.value = new ModelCssLengthProperty({
            mode: "absolute",
            value: e,
        });
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    onDropDownClick(e) {
    }

    onModeChange(e) {
        if (e === "auto") {
            this.props.source.value = new ModelCssLengthProperty({
                mode: "auto",
                value: 0,
            });
        }
        else if (e === "stretch") {
            this.props.source.value = new ModelCssLengthProperty({
                mode: "stretch",
                value: 0,
            });
        }
        else if (e === "px") {
            this.props.source.value = new ModelCssLengthProperty({
                mode: "absolute",
                value: this.props.source.minValueAbsolute === undefined ? 100 : this.props.source.minValueAbsolute,
            });
        }
        else {
            this.props.source.value = new ModelCssLengthProperty({
                mode: "percent",
                value: this.props.source.minValuePercent === undefined ? 100 : this.props.source.minValuePercent,
            });
        }
    }

    render() {

        let value = this.props.source.value;
        if (!value)
            return;

        const mode = value.mode;
        let modeText = "";
        if (mode === "auto")
            modeText = "自动";
        else if (mode === "stretch")
            modeText = "铺满";
        else if (mode === "absolute")
            modeText = "像素";
        else if (mode === "percent")
            modeText = "比例";

        value = value.value;

        const menu = (
            <Menu>
                <Menu.Item key="auto" onClick={e => this.onModeChange("auto")}>自动</Menu.Item>
                <Menu.Item key="stretch" onClick={e => this.onModeChange("stretch")}>铺满</Menu.Item>
                <Menu.Divider />
                <Menu.Item key="px" onClick={e => this.onModeChange("px")}>像素</Menu.Item>
                <Menu.Item key="percent" onClick={e => this.onModeChange("percent")}>比例</Menu.Item>
            </Menu>
        );

        return (
            <div className="property-editor--length">
                <div className="layout-h center hstretch">
                    {
                        mode === "auto" ? <Input
                            className="fill"
                            disabled /> : null
                    }
                    {
                        mode === "stretch" ? <Input
                            className="fill"
                            disabled /> : null
                    }
                    {
                        mode === "percent" ? <InputNumber
                            className="fill"
                            value={value}
                            formatter={value => `${value}%`}
                            parser={value => value.replace('%', '')}
                            min={this.props.source.minValuePercent === undefined ? -1000 : this.props.source.minValuePercent}
                            max={this.props.source.maxValuePercent === undefined ? 1000 : this.props.source.maxValuePercent}
                            onChange={e => this.onPercentChange(e)} /> : null
                    }
                    {
                        mode === "absolute" ? <InputNumber
                            className="fill"
                            value={value}
                            min={this.props.source.minValueAbsolute === undefined ? Number.MIN_SAFE_INTEGER : this.props.source.minValueAbsolute}
                            max={this.props.source.maxValueAbsolute === undefined ? Number.MAX_SAFE_INTEGER : this.props.source.maxValueAbsolute}
                            onChange={e => this.onPxChange(e)} /> : null
                    }
                    <Dropdown overlay={menu} trigger={['click']}>
                        <Button
                            className='sp-left btn-bd-focus-none btn-pd-sm btn-layer-node btn-bk-hover btn-bd-none'
                            style={{ padding: '5px 5px' }}>
                            {modeText} <DownOutlined type="down" style={{ marginLeft: 3, fontSize: 10 }} />
                        </Button>
                    </Dropdown>
                </div>
            </div>
        );
    }
}

PropertyGridUtils.register("css-length", (source, propertyGrid) => <CssLengthEditor source={source} propertyGrid={propertyGrid} />);